<template>
  <div class="part-info--card" style="display: flex; align-items: center; padding: 5px 10px;">
    <div style="max-width: 58px; margin-right: 20px; padding-top: 5px;">
      <Img style="width: 100%;" :src="imageplaceholderSrc" />
    </div>
    <div>
      <strong>{{ name }}</strong>&nbsp;<sup v-if="partState" :class="{ 'warning' : partState === 'draft', 'error': partState === 'invalid', 'success': partState === 'reviewed' }">{{ partState }}</sup>
      <div style="color: #9ea7b4; font-size: 12px;">{{ specification }}</div>
      <div style="color: #9ea7b4; font-size: 12px;" v-if="partNumber">{{ partNumber }}</div>
      <a @click="goToPartPage" style="font-size: 12px;">{{ $t('edit') }}</a>
    </div>
  </div>
</template>

<script>
import imageplaceholder from '@/assets/images/image-placeholder-grayscale.webp'
export default {
  name: 'PartInfoCard',
  props: {
    name: { type: String, required: true },
    specification: { type: String, required: true },
    partNumber: String,
    partState: String,
    partId: Number,
    partType: String
  },
  data () {
    return {
      imageplaceholderSrc: imageplaceholder
    }
  },
  methods: {
    goToPartPage () {
      let partRoute = this.$router.resolve({ name: `menu.${this.partType}.edit`, params: { partId: this.partId } })
      window.open(partRoute.href, '_blank')
    }
  }
}
</script>
